// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__34Xtc","header":"Messages_header__3aPeg"};